import type { ActiveError } from "./types"

const COOLDOWN_MS = 60_000

export const ReportIssueClient = {
  _lastReportTime: new Map<string, number>(),

  async report(error: ActiveError): Promise<void> {
    const last = this._lastReportTime.get(error.threadId) ?? 0
    if (Date.now() - last < COOLDOWN_MS) return
    this._lastReportTime.set(error.threadId, Date.now())

    await fetch("/api/v1/oio/report-error", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        thread_id: error.threadId,
        code: error.code,
        severity: error.severity,
        category: error.category,
        client_timestamp: error.timestamp,
      }),
    })
  },
}
